module.exports = __webpack_public_path__ + "img/server3.d76583b.png";